import React from "react";
import { Row, Col } from 'react-bootstrap';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import perPerson from '../../assets/images/per-person.svg';
import sqft from '../../assets/images/sqft.svg';
import { IRoomTypeData } from "../../types/api/homeApi";
import { NoData } from "../common/NoData";
import { useTranslation } from "react-i18next";

const RoomSuitsList: React.FC<{ room_types: Array<IRoomTypeData> }> = ({ room_types }) => {
    const {t} = useTranslation()
    const room_types_json = t('room_suite.rooms', { returnObjects: true })  as IRoomTypeData[];

    const roomsuitsSlider = {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        speed: 300,
        margin: '10px',
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };
    return (
        <div>
            <div>
                <section className='roomSuitlist'>
                    <div className='container'>
                        {<ul className='roomSuit-list'>
                            {
                                room_types && room_types.length ?
                                    room_types.map((room_type: IRoomTypeData, index: number) => (
                                        <li key={"room_suits_list_" + index}>
                                            <Row className="roomSuitlist-body">
                                                <Col md={12} lg={5} sm={12} className="p-0 m-0">
                                                    {<Slider {...roomsuitsSlider}>
                                                        {
                                                            room_type.photos && room_type.photos.length ?
                                                                room_type.photos.map((photo: string, index: number) => (
                                                                    <div className={`roomsuitsSlider-img ${index}`} key={"room_suits_photo_" + index}>
                                                                        <img src={photo} alt="img" />
                                                                    </div>
                                                                ))
                                                                :
                                                                <>
                                                                    <div className="roomsuitsSlider-img">
                                                                        <img src={require('../../assets/images/roomslider1.jpg')} alt="img" />
                                                                    </div>
                                                                    <div className="roomsuitsSlider-img">
                                                                        <img src={require('../../assets/images/roomslider1.jpg')} alt="img" />
                                                                    </div>
                                                                    <div className="roomsuitsSlider-img">
                                                                        <img src={require('../../assets/images/roomslider1.jpg')} alt="img" />
                                                                    </div>
                                                                </>
                                                        }
                                                    </Slider> }
                                                </Col>
                                                <Col md={12} lg={7} sm={12} className="p-0">
                                                    <div className="roomSuitlist-content">
                                                        <div className="room-desc">
                                                            <div className="room-name">
                                                                <h3>{room_types_json && room_types_json.length > 0 &&room_types_json[index].name}</h3>
                                                                <h4><span>${room_types_json && room_types_json.length > 0 &&room_types_json[index].base_price}/</span>{t('room_suite.night')}</h4>
                                                            </div>
                                                            <div className="rating-str">
                                                                <ul>
                                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                                    <li><i className="fa fa-star" aria-hidden="true"></i></li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <p className="room-text">{room_types_json && room_types_json.length > 0 &&room_types_json[index].description}</p>
                                                        <div className="person-details">
                                                            <ul className="info">
                                                                <li>
                                                                    <div className="room-content">
                                                                        <div className="icon">
                                                                            <img src={perPerson} alt="img" />
                                                                        </div>
                                                                        <div className="person-text">
                                                                            <h5>{room_types_json && room_types_json.length > 0 &&room_types_json[index].max_occupancy} {t('room_suite.person')}</h5>
                                                                            <p>{t('room_suite.guest')}</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                                <li>
                                                                    <div className="room-content">
                                                                        <div className="icon">
                                                                            <img src={sqft} alt="img" />
                                                                        </div>
                                                                        <div className="person-text">
                                                                            <h5>{room_type.size}</h5>
                                                                            <p>{t('room_suite.sqft_size')}</p>
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                            <button className="btn btn-black" onClick={()=>window.open(room_types_json && room_types_json.length > 0 ?room_types_json[index].link:"")}>{t('home.hero_section.book_now')}</button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </li>
                                    ))
                                    : <NoData message="Oops,No Room Types Found!!!" />
                            }
                        </ul>}
                    </div>
                </section>
            </div>
        </div>
    )
}
export default RoomSuitsList;